<template>
  <div class="flex justify-center w-full px-1 my-3">
    <!--
    <div class="w-full border-t-2 border-b-2 border-l border-r border-cyan-500 py-2 px-0.5"> -->
    <div class="w-full border-t-2 border-b-2 border-l border-r border-white py-2 px-0.5">
      <!-- .PRUEBA: <div> <LedSegments :segment=2 /> </div> :PRUEBA. -->
      <div class="grid grid-cols-5 gap-0.5">
        <div v-for="cellKey in cellKeys" :key="cellKey" :class="getCellClasses(cellKey)" >

          <!-- Para la celda a1 mostrar el componente LedSegments -->
          <!-- <LedSegments v-if="cellKey === 'a1' && um[cellKey]" :segment="parseInt(um[cellKey])" /> -->
          <template v-if="cellKey==='a1'" >
            <LedSegments v-if="inclLS && um[cellKey]" :segment="parseInt(um[cellKey])" />
          </template>

          <!-- Para el resto de celdas periféricas mostrar texto formateado -->
          <div
            v-else-if="(cellKey.charAt(1) === '1' || cellKey.charAt(0) === 'a') && um[cellKey]"
            v-html="getDisplayText(cellKey)"
          ></div>

          <!-- Para las demás celdas mostrar texto normal -->
          <div v-else>{{ um[cellKey] }}</div>

        </div> <!-- v-for -->
      </div> <!-- grid -->
    </div>
  </div>
</template>
//        $store.state.login.userLogin.info.default_setpoints.[0].tipo
<script>

import LedSegments from "./LedSegments.vue";

export default {
  name: 'ThresholdViewer',
  components: { LedSegments },
  props: {
    um: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      inclLS: false, // include Led Segments
      cellKeys: [
        'a1', 'b1', 'c1', 'd1', 'e1',
        'a2', 'b2', 'c2', 'd2', 'e2',
        'a3', 'b3', 'c3', 'd3', 'e3',
        'a4', 'b4', 'c4', 'd4', 'e4',
        'a5', 'b5', 'c5', 'd5', 'e5'
      ]
    }
  },
  methods: {
    getDisplayText(cellKey) {
      // const row = cellKey.charAt(1);
      // const col = cellKey.charAt(0);
      const text = this.um[cellKey];

      // Solo usar para las celdas periféricas (fila 1 o columna 'a') salvo a1
      if (typeof text === 'string') {
        const words = text.trim().split(/\s+/); // Dividir por espacios

        // Si tiene 2 o 3 palabras, dividir en 2 líneas
        if (words.length === 2) {
          return `${words[0]}<br>${words[1]}`;
        } else if (words.length === 3) {
          return `${words[0]}<br>${words[1]} ${words[2]}`;
        }
      }

      // En caso contrario, retornar el texto normal
      return text;
    },
  
    getCellClasses(cellKey) {
      const row = cellKey.charAt(1); // 1-5
      const col = cellKey.charAt(0); // a-e
      
      // Clases base (tamaño y alineación)
      let classes = 'flex items-center justify-center p-1 text-xs font-medium';
      
      // Alturas diferenciadas para filas 1 y 2
      if (row === '1') {
        classes += ' h-7'; // Un poco más baja
      } else if (row === '2') {
        // classes += ' h-5'; // Más baja
        classes += ' h-4'; // Más baja
      } else {
        classes += ' h-10'; // Altura normal
      }
      
      // Forzar una línea en celdas periféricas (fila 1 o columna 'a')
      if (row === '1' || col === 'a') {
        classes += ' whitespace-nowrap';
      }

      // Determinación de formato según posición
      const format = this.getFormat(row, col);
      // Determinación de gas según columna
      const gas = this.getGas(col);
      
      // Aplicar formato
      switch (format) {
        /*
        case 'A':
          // Formato A: periféricos: letra negra, fondo blanco, sin borde
          classes += ' text-gray-900 bg-teal-50 border border-gray-200';
          break;
        case 'B':
          // Formato B: unidades: letra celeste, fondo blanco, sin borde
          classes += ' text-cyan-600 bg-teal-50 border border-gray-200';
          break;  
        */
        case 'A': case 'B':
          // Formato A: periféricos: letra según gas, fondo blanco, sin borde
          // Formato B: unidades: letra según gas, fondo blanco, sin borde
          if(gas==='O2') {
            classes += ' text-blue-600';
          } else if(gas==='O3') {
            classes += ' text-purple-800';
          } else
            classes += ' text-gray-900';
          classes += ' bg-white border border-gray-50';
          break;

          case 'C': {
          // Formato C: umbrales: letra negra, fondo amarillo/blanco, borde morado/azul dinámico
          classes += ' text-gray-900 text-base';
          
          // Obtener condiciones
          const hasData = this.getDisplayText(cellKey);
          const hasMark = this.um[cellKey + '_m'];
     //    const hasColorBorder = this.um[cellKey + '_c'];
          const isControl = this.um[cellKey + '_c'];

          // Determinar fondo
          //classes += hasMark ? ' bg-yellow-50' : ' bg-yellow-200';
      //  classes += hasData !=null ? hasMark ? ' bg-yellow-50' : ' bg-yellow-200' : ' bg-gray-100';
          classes += hasData !=null ? hasMark ? ' bg-orange-50' : ' bg-orange-100' : ' bg-gray-00';

          /*
          // Determinar borde
      //  classes += hasColorBorder ? ' border-4 border-cyan-500 font-semibold text-blue-700' : ' border border-purple-700';
          classes += hasData != null ?
            isControl ? ' border-8 border-blue-600 font-semibold text-blue-700' : ' border-2 border-indigo-300' :
            ' ';
          */

          // Determinar borde: grueso según datos y control
          classes += hasData != null ? isControl ? ' border-8' : ' border-2' : '';
          // Determinar borde: color según gas
          classes += gas==='O2' ? ' border-blue-600' : gas==='O3' ? ' border-purple-800' : ' border-indigo-300';
          
          // Modificar texto: grueso según control
          classes += isControl ? ' font-semibold' : '';
          // Modificar texto: color según gas
          classes += gas==='O2' ? ' text-blue-600' : gas==='O3' ? ' text-purple-800' : '';

          break;
        }

        case 'D': {
          // Formato D: mediciones: letra medio, fondo blanco, ...

      //  classes += ' bg-white text-base text-gray-900';
          classes += ' bg-white text-base';

          // Color texto dependiente del gas
          classes += gas==='O2' ? ' text-blue-600' : gas==='O3' ? ' text-purple-800' : ' text-gray-900';

          // Para fila 4, heredar borde azul si fila 3 o 5 tienen _c verdadero
          if (row === '4' && col !== 'a') {
            const hasBorderInRow3 = this.um[col + '3_c'];
            const hasBorderInRow5 = this.um[col + '5_c'];

            if (hasBorderInRow3 || hasBorderInRow5) {
          //  classes += ' border-2 border-cyan-500 font-semibold text-blue-700';
          //  classes += ' border-4 border-blue-600 font-semibold text-blue-700';
              classes += ' border-4' + (gas==='O2' ? ' border-blue-600' : gas==='O3' ? ' border-purple-800' : '');
              classes += ' font-semibold' + (gas==='O2' ? ' text-blue-600' : gas==='O3' ? ' text-purple-800' : '');
            } else {
          //  classes += ' border border-cyan-400';
              classes += ' border-2 border-indigo-300';
            }
          } else {
        //  classes += ' border border-cyan-400';
            classes += ' border-2 border-indigo-300';
          }

          break;
        }

      }
      
      return classes;
    },
    
    getFormat(row, col) {
      // Matriz de formatos
      // Fila 1: AAAAA
      if (row === '1') return 'A';
      
      // Fila 2: BBBBB
      if (row === '2') return 'B';
      
      // Fila 3: ACCCC
      if (row === '3') return col === 'a' ? 'A' : 'C';
      
      // Fila 4: ADDDD
      if (row === '4') return col === 'a' ? 'A' : 'D';
      
      // Fila 5: ACCCC
      if (row === '5') return col === 'a' ? 'A' : 'C';
      
      return 'A'; // Por defecto
    },

    getGas(col) {
      switch(col)
      {
        case 'c':
        case 'd':
          return 'O2';
        case 'e':
          return 'O3';
        default:
          return '';
      } 
    }

  }
}
</script>
